import React, { FunctionComponent } from 'react';
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Image, Typography } from 'components/elements';
import { OnMobileOnly, OnTabletAndDesktopOnly } from 'utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './GrowthSlider.module.scss';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';
import { WPAcfGrowthItem } from 'types/acf/growth';
import DOMPurify from 'dompurify';

SwiperCore.use([Navigation, Pagination, A11y]);

interface OwnProps {
  data: WPAcfGrowthItem[];
}

type GrowthSliderProps = JSX.IntrinsicElements['section'] & OwnProps;

const GrowthSlider: FunctionComponent<GrowthSliderProps> = props => {
  const { data: items } = props;
  const { formatMessage } = useIntl();

  const a11y = {
    prevSlideMessage: formatMessage(messages.prev_slide),
    nextSlideMessage: formatMessage(messages.next_slide),
    paginationBulletMessage: formatMessage(messages.slide_message),
  };

  const renderSlider = (slidesPerView: number) => {
    return (
      <Swiper a11y={a11y} loop={true} slidesPerView={slidesPerView} navigation pagination={{ clickable: true }}>
        {items?.map((item, index) => {
          const { header, image, description } = item;
          return (
            <SwiperSlide key={`growth-slide-${index}`}>
              <div className={styles.sliderPage}>
                {image && (
                  <div className={styles.image}>
                    {/* TODO: Responsive check */}
                    <Image width={2} height={1} componentHeight={true} sizes="50vw" acfConfig={image} />
                  </div>
                )}
                <div className={styles.content}>
                  {header && (
                    <Typography mobile="new_neue_20_h2" as="div" className={styles.header}>
                      <h4>{DOMPurify.sanitize(header)}</h4>
                    </Typography>
                  )}
                  {description && (
                    <Typography
                      mobile="new_ibm_regular_16"
                      as="p"
                      className={styles.description}
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                    />
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  };

  return (
    <div className={styles.slider}>
      <OnMobileOnly>{renderSlider(1)}</OnMobileOnly>
      <OnTabletAndDesktopOnly>{renderSlider(1.48)}</OnTabletAndDesktopOnly>
    </div>
  );
};

export default GrowthSlider;
